import { Link } from "react-router-dom";
import { Icon } from "src/components/atoms/Icon/Icon";
import { Text } from "src/components/atoms/Text/Text";
import cn from "classnames";
import Styles from "./SearchInput.module.scss";
import TextInput from "src/components/atoms/TextInput/TextInput";
import { FormEvent } from "react";

interface SearchInputProps {
  handleChange: (event: FormEvent<HTMLInputElement>) => void;
  placeholder?: string;
  autoFocus?: boolean;
}

export const SearchInput = ({
  handleChange,
  placeholder = "Find a team, league, or tournament",
  autoFocus = false,
}: SearchInputProps) => {
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.inputWrapper}>
        <div aria-hidden="true" className={Styles.icon}>
          <Icon type={"magnify"} size="small" fill="coolGrey" />
        </div>
        <TextInput onChange={handleChange} placeholder={placeholder} className={cn(Styles.input)} autoFocus={autoFocus} />
      </div>
      <Link to="/teams" className={cn(Styles.link)}>
        <Text className={cn(Styles.linkText)} color="gc-blue" size="small" weight="semibold">
          Cancel
        </Text>
      </Link>
    </div>
  );
};
